import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
export default function ReadyForAConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ready-for-a-consultation" className="dark bg-background text-foreground relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/orange_county_map_texture.png')] bg-cover bg-center opacity-10 grayscale mix-blend-overlay" />
        <div className="bg-background/40 absolute inset-0" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        

        <div className="mb-12 flex flex-col items-center justify-center gap-3">
          <div className="bg-primary/10 flex h-12 w-12 items-center justify-center rounded-full">
            <MapPin className="text-primary h-6 w-6" />
          </div>
          <address className="font-serif text-2xl not-italic tracking-tight text-white/90 sm:text-3xl md:text-4xl">1 Hawkins Dr, Montgomery, NY 12549<br />HomeSmart Homes And Estates
          <div>LIC: 10311205625</div></address>
          <div className="bg-primary h-px w-24 opacity-50" />
        </div>

        <div className="flex flex-col items-center justify-center">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/image_qai8jlym.png" alt="Consultation" className="mb-8 max-w-full rounded-lg shadow-2xl md:max-w-md" />
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 animate-pulse px-10 text-lg font-semibold shadow-[0_0_20px_rgba(234,179,8,0.3)] transition-all hover:scale-105 hover:animate-none hover:shadow-[0_0_30px_rgba(234,179,8,0.5)]">
            <Link to="/ReachOutPage">Schedule a Consultation</Link>
          </Button>
        </div>
      </div>
    </section>;
}